function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.8 0.799985C12.8 0.355549 12.4257 0 11.9666 0H0.83321C0.370316 0 0 0.359185 0 0.799985C0 1.24443 0.374243 1.59997 0.83321 1.59997H11.9666C12.4257 1.60374 12.8 1.24443 12.8 0.799985Z",
  fill: "#5E5E5E"
});

function SvgMinusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 2,
    viewBox: "0 0 13 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMinusIcon;